import { iStorage } from 'smart-core-util'
var enviroment = process.env.NODE_ENV
var configuration = {
    development: {
        gateway: iStorage.getUrlGateway() || 'https://gateway-dev.smarteventcloud.cn',
        mark: "DEV"
    },
    staging: {
        gateway: iStorage.getUrlGateway() || 'https://gateway-stg.smarteventcloud.cn',
        mark: "STG"
    },
    production: {
        gateway: iStorage.getUrlGateway() || 'https://gateway.smarteventcloud.cn',
        mark: "LIVE"
    }
}[enviroment];

export default configuration;


// WEBPACK FOOTER //
// ./src/configuration.js